// Announcement.js component
import React from 'react';
import Popup from './Popup';

const Announcement = ({ showPopup, handleClose }) => {
    return (
        <Popup show={showPopup} handleClose={handleClose} popupTitle="Announcement" popupClass="announcement-popup">
            Announcement
        </Popup>
    );
};

export default Announcement;